import React from "react";
import Accordion from "pages/_components/Accordion";
import { arrayOf, string } from "prop-types";
import AccordionItem from "pages/_components/AccordionItem";

const CreditBillsAccordion = ({ className, item, table, label, handleExpandEndorsement }) => (
    <div className={`${className}`}>
        <Accordion>
            <AccordionItem key={label} number={1} toggleAccordion={handleExpandEndorsement} item={item}>
                {table}
            </AccordionItem>
        </Accordion>
    </div>
);

CreditBillsAccordion.propTypes = {
    label: arrayOf().isRequired,
    handleExpandEndorsement: string.isRequired,
    item: arrayOf().isRequired,
    table: arrayOf().isRequired,
    className: arrayOf().isRequired,
};

export default CreditBillsAccordion;
